import React from 'react';
import { Footer as HefoFooter } from '@juullabs/hefo';

const Footer = props => {
  return <HefoFooter {...props} />;
};

export default Footer;
